export class ContactInfoFieldHeaderResultDto {
  fieldName: string;
  caption: string;
  dataType: string;
  sequence: number;
  hidden: boolean;
  hiddenForUnassigned: boolean;
  //Transient or Computed field
  id: string;
}
